export * from "/codebuild/output/src2238631541/src/dgbet/local_modules/wallet/index.ts"